import { render, staticRenderFns } from "./fasilitas.vue?vue&type=template&id=5a773626"
import script from "./fasilitas.vue?vue&type=script&lang=js"
export * from "./fasilitas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports